import { Backdrop, CircularProgress, Portal } from "@mui/material";
import constate from "constate";
import { type ReactNode, useCallback, useState } from "react";

function useBackdropState() {
  const [isOpen, setIsOpen] = useState(false);

  const showBackdrop = useCallback(() => {
    setIsOpen(true);
  }, []);
  const hideBackdrop = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { isOpen, showBackdrop, hideBackdrop };
}

export const [BackdropStateProvider, useBackdrop] = constate(useBackdropState);

function BackdropConsumer({ children }: { children: ReactNode }) {
  const { isOpen } = useBackdrop();

  return (
    <>
      {children}
      {isOpen && (
        <Portal container={document.body}>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={isOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Portal>
      )}
    </>
  );
}

export function MuiBackdropProvider(props: { children: ReactNode }) {
  const { children } = props;
  return (
    <BackdropStateProvider>
      <BackdropConsumer>{children}</BackdropConsumer>
    </BackdropStateProvider>
  );
}
